// UQ-zh-HK
module.exports = {
  "forTest": "test for UQ-zh-HK",
  "text_styling_book_header_title": "STYLING BOOK",
  "text_styling_book_official_styling": "Official Styling",
  "text_styling_book_stylehint": "StyleHint",
  "text_sort": "排序",
  "text_filter": "篩選",
  "text_styling_book_search_results_number": "共 {total} 件",
  "text_active_filters": "篩選中的條件",
  "text_styling_book_clear_all_filters": "清除所有條件",
  "text_styling_book_search_by_feature": "依主題搜尋",
  "text_styling_book_search_by_category": "依商品分類搜尋",
  "text_styling_book_staff_customer_filter_all": "顯示全部",
  "text_styling_book_search_by_coordinate": "依穿搭搜尋",
  "text_styling_book_staff_customer_filter_title": "店員 / 顧客",
  "text_styling_book_search_by_height": "依身高搜尋",
  "text_styling_book_search_by_hashtag": "依主題標籤搜尋",
  "text_styling_book_staff_customer_filter_customer_styling": "顧客",
  "text_styling_book_staff_customer_filter_staff_styling": "UNIQLO 店員",
  "text_apply_search_filter": "確定",
  "text_styling_book_no_results": "非常抱歉，現在沒有符合你所選條件的穿搭。建議你變更條件再次進行篩選。",
  "text_error_title": "暫時無法使用。",
  "text_503_error_description-1": "非常抱歉出現了錯誤。",
  "text_503_error_description-2": "請稍待片刻後重新嘗試。",
  "text_503_error_instruction": "如有任何問題，請聯絡客服中心。",
  "text_styling_book_go_to_top": "UNIQLO TOP",
  "text_contactus": "客服中心",
  "text_wishlist": "收藏夾",
  "text_membership_info": "我的帳戶",
  "text_wearing_items": "穿搭單品",
  "text_color": "顏色",
  "text_size": "尺碼",
  "text_stylehint_non_listed_items_message_01": "※ 未顯示在上方的單品為 UNIQLO 現無發售之商品，或其它品牌的商品。",
  "text_styling_book_related_styling_title": "更多相關商品穿搭",
  "text_style_styling_date_update": "更新",
  "text_styling_book_hashtag_title": "主題標籤 ",
  "currency_format": "HK${price}",
  "text_404": "找不到頁面",
  "text_official_styling_top_page_link": "Official Styling TOP",
  "text_stylehint_top_page_link": "StyleHint TOP",
  "text_breadcrumbs_top": "UNIQLO",
  "text_a11y_close": "關閉",
  "text_log_in": "登入",
  "text_app_update_dialog_cancel": "取消",
  "text_menu": "目錄",
  "text_copyright": "Copyright © UNIQLO Co., Ltd. All rights reserved.",
  "text_stylehintapp": "StyleHint App",
  "text_styling_book_official_styling_page_title": "Official Styling",
  "text_styling_book_stylehint_page_title": "StyleHint",
  "text_styling_book_sort_latest": "依最新排序",
  "text_styling_book_sort_popular": "依人氣排序",
  "text_styling_book_search_by_color": "依顏色搜尋",
  "text_filter_clear_all_category": "清除所有類別",
  "text_styling_book_filter_height_over": "以上",
  "text_styling_book_filter_height_under": "以下",
  "text_show_all": "顯示全部",
  "text_error_description": "系統發生錯誤，請重試或稍後再試。",
  "text_system_error": "系統錯誤",
  "text_ok": "OK",
  "text_login_required": "請先登入",
  "text_login_request": "請登入後再繼續。",
  "text_error_failed_sort_product": "無法找到符合條件的商品，請變更條件後再嘗試。",
  "text_error_failed_update_filter_criteria": "無法更新篩選條件，請再試一次。",
  "text_meta_title_postfix": "| UNIQLO香港及澳門",
  "text_meta_title_prefix": "UNIQLO香港及澳門 |",
  "text_styling_book_meta_title_brand": "UNIQLO香港及澳門",
  "text_styling_book_meta_women": "女裝",
  "text_styling_book_meta_men": "男裝",
  "text_styling_book_meta_kids": "童裝",
  "text_styling_book_meta_baby": "嬰幼兒",
  "text_styling_book_official_gender_meta_description": "{brand} 官方穿搭，了解 {gender} LifeWear 商品的最新流行趨勢。",
  "text_styling_book_official_gender_meta_title": "官方穿搭指南 | {gender} | Official Styling  {uqPostfix}",
  "text_styling_book_official_gender_filter_meta_title": "{gender}的「{filterOptions}」相關穿搭 {uqPostfix}",
  "text_styling_book_official_gender_filter_meta_description": "透過 {brand} 的 LifeWear 商品了解{gender}的「{filterOptions}」相關穿搭。",
  "text_styling_book_official_detail_meta_title": "「{officialProducts}」穿搭推薦 {uqPostfix}",
  "text_styling_book_official_detail_meta_description": "{brand}「{officialProducts}」的穿搭介紹，在網絡旗艦店瀏覽如何搭配流行單品。",
  "text_styling_book_stylehint_gender_meta_title": "穿搭靈感 | {gender} | StyleHint {uqPostfix}",
  "text_styling_book_stylehint_gender_meta_description": "{brand}官方StyleHint，透過店員及顧客在StyleHint APP上傳的照片，發掘{gender}流行穿搭風格！",
  "text_styling_book_stylehint_filter_meta_title": "{gender}的「{filterOptions}」穿搭靈感 {uqPostfix}",
  "text_styling_book_stylehint_store_user_meta_title": "{userName}({storeName})的穿搭靈感一覽 {uqPostfix}",
  "text_styling_book_stylehint_ins_user_meta_title": "{userName}的穿搭靈感 {uqPostfix}",
  "text_styling_book_stylehint_customer_user_meta_title": "{userName}({height})的穿搭靈感 {uqPostfix}",
  "text_styling_book_stylehint_detail_meta_title": "「{stylehintProducts}」的穿搭靈感 {uqPostfix}",
  "text_styling_book_stylehint_store_user_meta_description": "探索{brand}({storeName})的店員{staffName}({height})穿搭，看看店員如何搭配造型。",
  "text_styling_book_stylehint_ins_user_meta_description": "探索Instagram 用戶「{userName}」的穿搭，看看他們如何運用{brand}單品搭配造型。",
  "text_styling_book_stylehint_customer_user_meta_description": "探索{userName}({height})的穿搭，看看他們如何運用{brand}單品搭配造型。",
  "text_styling_book_stylehint_detail_meta_description": "探索{brand}的「{stylehintProducts}」穿搭，看看店員及顧客的實際穿搭推薦！",
  "text_styling_book_stylehint_filter_meta_description": "探索「{searchCount}」件{brand}「{filterOptions}」的相關穿搭，瀏覽如何搭配造型。",
  "text_styling_book_stylehint_styling_id_alt_tag": "{brand} STYLING BOOK - StyleHint Style ID:<{styleId}>",
  "text_styling_book_official_styling_id_alt_tag": "{brand} STYLING BOOK - Official Styling Style ID:<{styleId}>",
  "text_styling_book_official_detail_id_alt_tag": "「{officialProducts}」的穿搭推薦",
  "text_styling_book_stylehint_detail_id_alt_tag": "探索「{stylehintProducts}」的穿搭靈感",
  "text_styling_book_product_id_alt_tag": "{productName} {gender}",
  "text_styling_book_stylehint_user_id_alt_tag": "{userName}",
  "text_styling_book_stylehint_hashtag_alt_tag": "{gender}「{hashtag}」的穿搭一覽",
  "text_styling_book_stylehint_feature_alt_tag": "{gender}「{feature}」的穿搭一覽",
  "text_style_model_height": "cm",
  "text_503_error_description": "非常抱歉，系統發生錯誤，請稍後重新嘗試。",
  "text_styling_book_meta_official_styling": "Official Styling",
  "text_styling_book_meta_stylehint": "StyleHint",
  "text_limited_offer_until_date": "",
  "text_online_store_exclusive_limited_offer_until_date": "",
  "text_app_membership_exclusive_limited_offer_until": "",
  "text_csoon_early": "",
  "text_csoon_mid": "",
  "text_csoon_late": "",
  "text_men": "MEN",
  "text_women": "WOMEN",
  "text_kids": "KIDS",
  "text_baby": "BABY",
  "text_unisex": "",
  "text_app_membership_exclusive_limited_offer": "",
  "text_styling_book_gender_menu_kids_and_baby": "Kids & Baby",
  "text_styling_book_meta_kids_and_baby": "KIDS・BABY",
  "text_a11y_favorites_add": "",
  "text_close": "",
  "text_error_wishlist_max": "收藏夾已滿, 無法添加商品, 請移至收藏夾頁面重新整理",
  "text_size_multiplication_sign": "",
  "text_no_image": "",
  "text_wearing_size_code01": "",
  "text_locale_hk_zh": "繁體中文",
  "text_locale_en": "ENGLISH",
  "text_locale_fr": "",
  "text_locale_th": "",
  "text_locale_id": "",
  "text_locale_vi": "",
  "text_locale_de": "",
  "text_locale_es": "",
  "text_locale_it": "",
  "text_locale_nl": "",
  "text_product_unavailable": "停止發售",
  "text_product_display_markdown": "",
  "text_color_white": "",
  "text_color_gray": "",
  "text_color_black": "",
  "text_color_pink": "",
  "text_color_red": "",
  "text_color_orange": "",
  "text_color_beige": "",
  "text_color_brown": "",
  "text_color_yellow": "",
  "text_color_green": "",
  "text_color_blue": "",
  "text_color_purple": "",
  "text_promotion": "推廣",
  "text_styling_promotion_hashtag": "推廣",
  "text_coming_soon": "",
  "text_markdown": "",
  "text_multibuy_markdown": "",
  "text_multibuy_limited_offer_until_date": "",
  "text_app_membership_exclusive_multi_buy_until": "",
  "text_app_membership_exclusive_multi_buy": "",
  "text_app_membership_exclusive_limitedoffers_until": "",
  "text_item_preorder_color_size_only": "",
  "text_item_resale_color_size_only": ""
}; // generated at Wed Apr 02 2025 13:40:29 GMT+0800 (Hong Kong Standard Time)